import { emptyAppliedFilter, hasAppliedPredicate, migrateAppliedFilter } from "./advancedFilters";

const appliedKey = layerId => `attrTable_applied_v1_${layerId}`;
const enabledKey = layerId => `attrTable_filter_enabled_v1_${layerId}`;

export const readSavedAttributeFilter = layerId => {
  try {
    const value = migrateAppliedFilter(JSON.parse(sessionStorage.getItem(appliedKey(layerId)) || "null"));
    return hasAppliedPredicate(value) ? value : null;
  } catch (error) {
    return null;
  }
};

export const isAttributeFilterEnabled = layerId => (
  !!readSavedAttributeFilter(layerId) && sessionStorage.getItem(enabledKey(layerId)) !== "false"
);

export const effectiveAttributeFilter = layerId => (
  isAttributeFilterEnabled(layerId) ? readSavedAttributeFilter(layerId) : emptyAppliedFilter()
);

export const setAttributeFilterEnabled = (layerId, enabled) => {
  sessionStorage.setItem(enabledKey(layerId), enabled ? "true" : "false");
  window.dispatchEvent(new CustomEvent("attribute-filter-state-change", { detail: { layerId, enabled: !!enabled } }));
};

export const notifyAttributeFilterChanged = layerId => {
  window.dispatchEvent(new CustomEvent("attribute-filter-state-change", { detail: { layerId } }));
};

// writeSavedAttributeFilter persiste `applied` como el filtro activo de
// layerId — extraído de store/modules/attributeTable.js::commitAppliedFilter
// (que antes era el único escritor, pero solo persistía `if (state.layer)`:
// con la tabla de esa capa cerrada, o con la tabla de OTRA capa abierta, no
// escribía nada o pisaba el filtro equivocado). Cargar un preset guardado
// desde ListPlegable.vue (tabla cerrada) necesita este mismo efecto sin
// pasar por ese estado. commitAppliedFilter sigue siendo el único punto que
// además sincroniza el Vuex state (columnFilters/advancedDraft) cuando la
// tabla de esa capa está abierta — este helper solo hace la mitad de
// persistencia, igual byte a byte a como ya se hacía.
export const writeSavedAttributeFilter = (layerId, applied) => {
  sessionStorage.setItem(appliedKey(layerId), JSON.stringify(applied));
  sessionStorage.setItem(enabledKey(layerId), hasAppliedPredicate(applied) ? "true" : "false");
  sessionStorage.removeItem(`attrTable_filters_${layerId}`);
  sessionStorage.removeItem(`attrTable_spatial_${layerId}`);
  notifyAttributeFilterChanged(layerId);
};

// Estas claves solo incluyen el layerId, no el usuario — necesario llamar
// esto al cerrar sesión (Logout.vue, main.js::errorHandler en 403), si no el
// próximo usuario que use la misma pestaña hereda (y puede aplicar sin
// darse cuenta) el filtro de atributos que dejó aplicado el usuario anterior.
export const clearAllAttributeFilterState = () => {
  Object.keys(sessionStorage)
    .filter(key => key.startsWith("attrTable_"))
    .forEach(key => sessionStorage.removeItem(key));
};
